import { RoleEntity } from "modules/company/entities";
import { RoleDeleteModal, RoleDuplicateModal, RoleRenameModal } from "modules/company/features";
import { useMyPermissions } from "modules/my-permissions";
import React, { CSSProperties, useCallback } from "react";
import { CompanyEmployeeRoleDto, CompanyEmployeeRoleType } from "shared/api";
import { Modals } from "shared/lib";
import { IListData, List, MenuItem } from "shared/ui";

export interface IRoleList extends IListData<CompanyEmployeeRoleDto> {
  companySlug: string;

  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const RoleList = (props: IRoleList) => {
  const roleWritePermission = useMyPermissions(props.companySlug)?.company.roles.write;

  const onRename = useCallback(
    (data: CompanyEmployeeRoleDto) =>
      Modals.open(RoleRenameModal, {
        companySlug: props.companySlug,
        data,
        onSuccess: () => props.mutate?.(),
      }),
    [props.companySlug, props.mutate]
  );

  const onDuplicate = useCallback(
    (data: CompanyEmployeeRoleDto) =>
      Modals.open(RoleDuplicateModal, {
        companySlug: props.companySlug,
        data,
        onSuccess: () => props.mutate?.(),
      }),
    [props.companySlug, props.mutate]
  );

  const onDelete = useCallback(
    (data: CompanyEmployeeRoleDto) =>
      Modals.open(RoleDeleteModal, {
        companySlug: props.companySlug,
        data,
        onSuccess: () => props.mutate?.(),
      }),
    [props.companySlug, props.mutate]
  );

  return (
    <List
      {...props}
      renderItem={(it) => {
        const editable = it.type === CompanyEmployeeRoleType.COMMON;

        return (
          <RoleEntity
            data={it}
            companySlug={props.companySlug}
            onUpdated={() => props.mutate?.()}
            readOnly={!roleWritePermission}
            menuItems={
              roleWritePermission && (
                <>
                  {editable && <MenuItem onClick={() => onRename(it)}>Переименовать</MenuItem>}
                  <MenuItem onClick={() => onDuplicate(it)}>Дублировать</MenuItem>
                  {editable && (
                    <MenuItem type="error" onClick={() => onDelete(it)}>
                      Удалить
                    </MenuItem>
                  )}
                </>
              )
            }
          />
        );
      }}
    />
  );
};

RoleList.defaultProps = {};
